import { css, cva } from '@/styled-system/css';

// Container styles with variants
export const containerStyles = cva({
  base: {
    width: '100%',
    boxSizing: 'border-box',
  },
  variants: {
    isPopup: {
      false: {
        background: 'hpxTeal500',
        color: 'hpxWhite',
        padding: '2x',
      },
      true: {
        background: 'hpxWhite',
        color: 'hpxBlue600',
        padding: '0',
        boxShadow: 'none',
        border: 'none',
        outline: 'none',
        width: '100%',
        maxWidth: '100%',
        marginTop: '0',
        marginRight: 'auto',
        marginBottom: '0',
        marginLeft: 'auto',
        md: {
          maxWidth: '420px',
        },
      },
    },
  },
  defaultVariants: {
    isPopup: false,
  },
});

// Content wrapper styles with variants
export const contentWrapperStyles = cva({
  base: {
    background: 'hpxWhite',
    borderRadius: '4px',
    width: '100%',
    boxSizing: 'border-box',
  },
  variants: {
    isInline: {
      true: {
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
      },
      false: {
        borderRadius: '0',
      },
    },
  },
});

// Content styles with variants
export const contentStyles = cva({
  base: {
    position: 'relative',
    color: 'hpxGrey600',
    padding: '2x',
    boxSizing: 'border-box',
    width: '100%',
    xl: {
      padding: '4x',
    },
  },
  variants: {
    isPopup: {
      true: {
        padding: '0',
        xl: {
          padding: '0',
        },
      },
    },
  },
});

// Disclaimer styles with variants
export const disclaimerStyles = cva({
  base: {
    paddingTop: '2x',
  },
  variants: {
    isPopup: {
      true: {
        color: 'hpxBlack',
        paddingTop: '0',
        paddingRight: '32px',
        paddingBottom: '16px',
        paddingLeft: '32px',
      },
    },
  },
});

// Static styles that don't need variants
export const contactStyles = {
  // Header styles - HdpForm-Contact-header
  header: css({
    fontWeight: 'bold',
    textShadow: '0 2px 2px rgba(0, 0, 0, 0.2)',
  }),

  // Modal styles - HdpForm-Contact-modal
  modal: css({
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    width: '100%',
    height: '100%',
  }),

  satelliteWrapper: css({
    margin: '16px',
  }),
};
